(function () {
  var params = new URLSearchParams(window.location.search);
  var enabled = params.has("mira_live_chat_test") || params.has("codex_mira_live_chat_batch");
  if (!enabled || document.getElementById("mira-live-chat-test-root")) return;

  var endpoint = "https://cs-ai-agent-l2xymbxhra-uc.a.run.app/api/cs-agent/live-chat/respond";
  var sessionId = "website-test-" + Date.now().toString(36);
  var category = "order_question";

  var style = document.createElement("style");
  style.textContent = [
    "#mira-live-chat-test-root{position:fixed;left:18px;bottom:18px;z-index:2147483000;width:min(390px,calc(100vw - 36px));font-family:Inter,Arial,sans-serif;color:#172033}",
    "#mira-live-chat-test-root *{box-sizing:border-box}",
    ".mira-test-panel{background:#fff;border:1px solid #cfd7e6;box-shadow:0 18px 44px rgba(15,23,42,.22);border-radius:8px;overflow:hidden}",
    ".mira-test-head{display:flex;align-items:center;justify-content:space-between;gap:10px;padding:12px 14px;background:#0b4a7a;color:#fff}",
    ".mira-test-title{font-weight:700;font-size:14px;line-height:1.2}",
    ".mira-test-sub{font-size:12px;opacity:.9;margin-top:2px}",
    ".mira-test-close{border:0;background:transparent;color:#fff;font-size:22px;line-height:1;cursor:pointer;padding:0 2px}",
    ".mira-test-body{padding:12px;background:#f7f9fc}",
    ".mira-test-row{display:flex;gap:8px;margin-bottom:8px}",
    ".mira-test-field,.mira-test-select,.mira-test-input{width:100%;border:1px solid #cbd5e1;background:#fff;border-radius:6px;padding:8px 9px;font-size:13px;color:#172033}",
    ".mira-test-select{appearance:auto}",
    ".mira-test-transcript{height:220px;overflow:auto;background:#fff;border:1px solid #dbe3ef;border-radius:6px;padding:10px;margin:8px 0}",
    ".mira-test-msg{font-size:13px;line-height:1.42;margin:0 0 10px;white-space:pre-wrap}",
    ".mira-test-msg strong{display:block;font-size:11px;text-transform:uppercase;letter-spacing:.04em;margin-bottom:3px;color:#52637a}",
    ".mira-test-msg.user{color:#172033}",
    ".mira-test-msg.mira{color:#0f3f63}",
    ".mira-test-actions{display:grid;grid-template-columns:1fr 1fr;gap:7px;margin-bottom:8px}",
    ".mira-test-chip,.mira-test-send{border:1px solid #b8c5d8;background:#fff;color:#17324d;border-radius:6px;padding:8px;font-size:12px;cursor:pointer;text-align:center}",
    ".mira-test-chip:hover,.mira-test-send:hover{background:#edf5fc}",
    ".mira-test-send{background:#0b4a7a;color:#fff;border-color:#0b4a7a;font-weight:700}",
    ".mira-test-send[disabled]{opacity:.6;cursor:not-allowed}",
    ".mira-test-foot{font-size:11px;line-height:1.35;color:#52637a;margin-top:8px}",
  ].join("");
  document.head.appendChild(style);

  var root = document.createElement("div");
  root.id = "mira-live-chat-test-root";
  root.innerHTML = [
    '<div class="mira-test-panel" role="dialog" aria-label="Mira live chat test">',
    '  <div class="mira-test-head">',
    '    <div><div class="mira-test-title">Mira AI test chat</div><div class="mira-test-sub">Internal Bala/Codex test only</div></div>',
    '    <button class="mira-test-close" type="button" aria-label="Close Mira test chat">&times;</button>',
    '  </div>',
    '  <div class="mira-test-body">',
    '    <select class="mira-test-select" aria-label="Inquiry category">',
    '      <option value="order_question">Order question</option>',
    '      <option value="product_question">Product question</option>',
    '      <option value="issue_with_order">Issue with order</option>',
    '      <option value="general_inquiry">General inquiry</option>',
    '    </select>',
    '    <div class="mira-test-row" style="margin-top:8px">',
    '      <input class="mira-test-field mira-test-email" autocomplete="email" placeholder="Email optional" aria-label="Email">',
    '      <input class="mira-test-field mira-test-order" inputmode="numeric" placeholder="Order # optional" aria-label="Order number">',
    '    </div>',
    '    <div class="mira-test-actions">',
    '      <button class="mira-test-chip" type="button" data-cat="product_question" data-text="How many masks are in a bag?">Mask bag count</button>',
    '      <button class="mira-test-chip" type="button" data-cat="general_inquiry" data-text="What are your customer service hours?">Support hours</button>',
    '      <button class="mira-test-chip" type="button" data-cat="order_question" data-order="1176053" data-text="Where is order #1176053?">Order 1176053</button>',
    '      <button class="mira-test-chip" type="button" data-cat="order_question" data-text="I need a live agent">Human handoff</button>',
    '    </div>',
    '    <div class="mira-test-transcript" aria-live="polite"></div>',
    '    <div class="mira-test-row">',
    '      <input class="mira-test-input" placeholder="Ask Mira a test question" aria-label="Message">',
    '      <button class="mira-test-send" type="button">Send</button>',
    '    </div>',
    '    <div class="mira-test-foot">Retrieval-only test. Mira can read KB/order context but should not perform refunds, cancellations, holds, tags, closes, notes, or subscription edits.</div>',
    '  </div>',
    '</div>',
  ].join("");
  document.body.appendChild(root);

  var transcript = root.querySelector(".mira-test-transcript");
  var select = root.querySelector(".mira-test-select");
  var emailInput = root.querySelector(".mira-test-email");
  var orderInput = root.querySelector(".mira-test-order");
  var messageInput = root.querySelector(".mira-test-input");
  var sendButton = root.querySelector(".mira-test-send");

  function addMessage(who, text) {
    var message = document.createElement("p");
    message.className = "mira-test-msg " + (who === "Mira" ? "mira" : "user");
    message.innerHTML = "<strong></strong><span></span>";
    message.querySelector("strong").textContent = who;
    message.querySelector("span").textContent = text;
    transcript.appendChild(message);
    transcript.scrollTop = transcript.scrollHeight;
  }

  async function send(text, override) {
    var clean = (text || "").trim();
    if (!clean) return;

    var selectedCategory = (override && override.category) || category;
    var orderNumber = (override && override.orderNumber) || orderInput.value.trim() || null;
    var email = emailInput.value.trim() || null;

    select.value = selectedCategory;
    category = selectedCategory;
    if (orderNumber) orderInput.value = orderNumber;
    messageInput.value = "";
    sendButton.disabled = true;
    addMessage("Test user", clean);

    try {
      var response = await fetch(endpoint, {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({
          session_id: sessionId,
          message: clean,
          selected_category: selectedCategory,
          email: email,
          order_number: orderNumber,
        }),
      });
      var payload = await response.json();
      if (!response.ok) throw new Error(payload.detail || response.statusText);
      addMessage("Mira", payload.reply + "\\n\\nroute=" + payload.route + " sources=" + (payload.sources || []).join(",") + " actions=" + (payload.actions_performed || []).length);
    } catch (error) {
      addMessage("Mira", "Test error: " + (error && error.message ? error.message : String(error)));
    } finally {
      sendButton.disabled = false;
      messageInput.focus();
    }
  }

  root.querySelector(".mira-test-close").addEventListener("click", function () {
    root.remove();
  });
  select.addEventListener("change", function () {
    category = select.value;
  });
  sendButton.addEventListener("click", function () {
    send(messageInput.value);
  });
  messageInput.addEventListener("keydown", function (event) {
    if (event.key === "Enter") send(messageInput.value);
  });
  root.querySelectorAll(".mira-test-chip").forEach(function (button) {
    button.addEventListener("click", function () {
      send(button.getAttribute("data-text"), {
        category: button.getAttribute("data-cat"),
        orderNumber: button.getAttribute("data-order") || null,
      });
    });
  });

  addMessage("Mira", "I'm Mira, WellBefore's AI assistant. This is an internal test chat connected to the live Mira endpoint.");
})();
